var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ProfileCount" }, [
    _c("span", [_vm._v(_vm._s(_vm.object.count))]),
    _vm._v(" "),
    !_vm.object.userCanUpdate
      ? _c(
          "span",
          {
            attrs: {
              title: _vm.$t("profile.errors.user_has_no_dati_visibility"),
            },
          },
          [_c("i", { staticClass: "ml-1 fa fa-lock" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }